import * as React from "react";

const AwesomeEnvelope: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="27" viewBox="0 0 36 27">
            <path id="Icon_awesome-envelope" data-name="Icon awesome-envelope" d="M35.318,13.416a.423.423,0,0,1,.682.33V28.125A3.376,3.376,0,0,1,32.625,31.5H3.375A3.376,3.376,0,0,1,0,28.125V13.753a.421.421,0,0,1,.682-.33C2.257,14.646,4.345,16.2,11.517,21.41,13,22.493,15.5,24.771,18,24.757c2.51.021,5.063-2.306,6.49-3.347C31.662,16.2,33.743,14.639,35.318,13.416ZM18,22.5c1.631.028,3.98-2.053,5.161-2.911,9.33-6.771,10.041-7.362,12.192-9.049A1.683,1.683,0,0,0,36,9.211V7.875A3.376,3.376,0,0,0,32.625,4.5H3.375A3.376,3.376,0,0,0,0,7.875V9.211A1.693,1.693,0,0,0,.647,10.54c2.152,1.68,2.862,2.278,12.192,9.049C14.02,20.447,16.369,22.528,18,22.5Z" transform="translate(0 -4.5)" />
        </svg>
    );
};

export default React.memo(AwesomeEnvelope);
